import {
  InputGroup,
  Radio,
  RadioGroup,
  Spinner,
  Stack,
} from "@chakra-ui/react";
import { useAtom } from "jotai";
import React, { useEffect, useRef, useState } from "react";
import { HiCheckCircle } from "react-icons/hi";
import { MdErrorOutline } from "react-icons/md";
import { useField } from "../../../../hooks/FormGeneratorHooks";
import { userAtom } from "../../../../state/auth";
import { FormGroup } from "../FormGroup";

const FieldRadio: React.FunctionComponent<any> = (props) => {
  let { name, error, options, direction, inputName, required, ...rest } = props;

  const {
    errorMessage,
    id,
    isValid,
    isSubmitted,
    resetKey,
    setValue,
    value,
    otherProps,
  } = useField(props);

  const [isTouched, setIsTouched] = useState(true);
  const [isValidation, setIsValidation] = useState(false);
  const [user] = useAtom(userAtom);
  const showError = !isValid && (isTouched || isSubmitted);
  const { children, label, type, placeholder, helper, ...resta } = otherProps;
  // The answer the user just chose, until the server copy confirms it. Copies
  // that still carry the old answer arrive in between and must not undo it.
  const pendingRef = useRef<string | null>(null);
  const pendingTimer = useRef<any>(null);
  const serverValueRef = useRef(rest.value);
  const valueOf = (v: any) => (v && (v.value || v)) || null;

  useEffect(() => {
    setIsTouched(true);
  }, [resetKey]);
  useEffect(() => {
    serverValueRef.current = rest.value;
    if (pendingRef.current !== null) {
      if (valueOf(rest.value) !== pendingRef.current) {
        return;
      }
      pendingRef.current = null;
    }
    if (rest.value) {
      setValue(rest.value);
    }
  }, [rest.value, setValue]);

  useEffect(() => () => clearTimeout(pendingTimer.current), []);

  const formGroupProps = {
    errorMessage,
    helper: isTouched ? helper : "",
    id,
    isRequired: required,
    label,

    showError,
    name,

    ...resta,
  };

  const handleChange = (value: string) => {
    if (!options) {
      return;
    }
    const completeValue = options.find((f: any) => f.value === value);
    if (pendingRef.current === completeValue.value) {
      return;
    }
    setValue(completeValue.value);

    if (props?.onSumbit) {
      pendingRef.current = completeValue.value;
      clearTimeout(pendingTimer.current);
      // if the server never answers, go back to what it holds
      pendingTimer.current = setTimeout(() => {
        pendingRef.current = null;
        if (serverValueRef.current) {
          setValue(serverValueRef.current);
        }
      }, 3000);
      props.onSumbit({
        fieldName: name,
        value: completeValue.value,
        isValid: true,
      });
    }
  };
  // console.log("showError",showError,"errorMessage",errorMessage,"isValid",isValid)
  return (
    <FormGroup className="mt-3" {...formGroupProps}>
      <InputGroup>
        <RadioGroup
          {...rest}
          value={
            value !== null && value !== undefined
              ? value && (value.value || value)
              : rest.value && (rest.value.value || rest.value)
          }
          onChange={(e: string) => {
            setIsTouched(true);
            handleChange(e);
            setIsValidation(true);
          }}
          onBlur={(e) => {
            setIsValidation(false);
          }}
          className={isValid ? " px-2 py-1  " : "px-2 py-1 "}
        >
          <Stack
            className={
              props.disabled ? "pointer-events-none cursor-not-allowed" : ""
            }
            direction={direction || "row"}
          >
            {options &&
              options.map((item: any, index: number) => (
                <React.Fragment key={`${index}`}>
                  <Radio
                    _checked={{ bg: "blue" }}
                    key={index}
                    value={item.value}
                    onClick={(e) => handleChange(item.value)}
                    isDisabled={props.disabled ? true : false}
                    _disabled={{ _checked: { background: "blue" } }}
                  >
                    <p style={{ fontSize: "14px" }}>{item.label}</p>
                  </Radio>
                  <span style={{ marginRight: "2rem" }} />
                </React.Fragment>
              ))}
          </Stack>
        </RadioGroup>
      </InputGroup>
      {!props?.isPreview && user?.type === "writer" && (
        <div className="absolute -left-8 top-1/2">
          {" "}
          {isValidation && (
            <p>
              <Spinner size="sm" flex="none" color="blue.200" />
            </p>
          )}
          <p>
            {" "}
            {isValid && !isValidation && (
              <HiCheckCircle color="#67d428" width={20} height={20} />
            )}
            {!isValid && !isValidation && (
              <MdErrorOutline color="#ff0000" width={20} height={20} />
            )}
          </p>
        </div>
      )}

      {children}
    </FormGroup>
  );
};

export default FieldRadio;
